import React, { useState, useEffect } from 'react';

const Timer = () => {
  const [progress, setProgress] = useState(0);
  const [countdown, setCountdown] = useState(8);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress(prev => {
        const newProgress = prev + (100 / 8); // 100% en 8 secondes = 12.5% par seconde
        if (newProgress >= 100) {
          setCountdown(8); // Reset countdown
          return 0; // Reset progress
        }
        setCountdown(Math.ceil(8 - (newProgress / 100) * 8));
        return newProgress;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Calculer la couleur en fonction du progrès (rouge → orange → jaune pour créer l'urgence)
  const getProgressColor = (progress) => {
    if (progress < 33) return '#ef4444'; // Rouge - danger imminent
    if (progress < 66) return '#f97316'; // Orange - attention
    return '#eab308'; // Jaune - alerte
  };

  const strokeDasharray = 2 * Math.PI * 45; // Circonférence du cercle (rayon = 45)
  const strokeDashoffset = strokeDasharray - (progress / 100) * strokeDasharray;

  return (
    <div className="glass p-8 rounded-3xl max-w-2xl mx-auto">
      <div className="flex flex-col items-center">
        {/* Timer visuel moderne avec SVG */}
        <div className="relative w-36 h-36 mb-6">
          {/* SVG pour la jauge circulaire */}
          <svg className="w-full h-full transform -rotate-90" viewBox="0 0 100 100">
            {/* Cercle de fond */}
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke="rgba(75, 85, 99, 0.3)"
              strokeWidth="6"
              fill="none"
            />
            {/* Jauge de progression */}
            <circle
              cx="50"
              cy="50"
              r="45"
              stroke={getProgressColor(progress)}
              strokeWidth="6"
              fill="none"
              strokeLinecap="round"
              strokeDasharray={strokeDasharray}
              strokeDashoffset={strokeDashoffset}
              className="transition-all duration-1000 ease-in-out"
              style={{
                filter: `drop-shadow(0 0 8px ${getProgressColor(progress)}40)`,
              }}
            />
          </svg>
          
          {/* Contenu central */}
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <div className="text-3xl font-bold text-white mb-1">{countdown}</div>
            <div className="text-xs text-gray-300 font-medium">secondes</div>
          </div>
          
          {/* Effet de pulsation quand proche de zéro */}
          {progress > 75 && (
            <div className="absolute inset-0 rounded-full bg-red-500 opacity-20 animate-pulse"></div>
          )}
        </div>
        
        {/* Texte avec effet d'urgence */}
        <div className="text-center">
          <p className={`text-lg font-semibold mb-2 transition-colors duration-500 ${
            progress > 75 ? 'text-red-300' : 'text-white'
          }`}>
            Toutes les 8 secondes
          </p>
          <p className={`text-base transition-colors duration-500 ${
            progress > 75 ? 'text-red-200' : 'text-blue-300'
          }`}>
            un sinistre est déclaré à l'assurance en Suisse
          </p>
        </div>
        
        {/* Indicateur d'urgence */}
        {progress > 75 && (
          <div className="mt-4 px-4 py-2 bg-red-500/20 border border-red-500/30 rounded-full">
            <p className="text-red-300 text-sm font-medium animate-pulse">
              ⚠️ Nouveau sinistre imminent !
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Timer;